import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { ErrorBoundary, useErrorBoundary } from "react-error-boundary";
import { Error } from "~/components/Error";
import { Loading } from "~/components/Loading";
import { usePlayerActions } from "../actions";
import { usePlayerLog, usePlayerTopics } from "../hooks";
import { Panels, usePanelContext } from "../panels";
import { VisualizationSwitch } from "../visualizations";

export function TopicSection() {
  const logQuery = usePlayerLog();

  const topicsQuery = usePlayerTopics();

  return (
    <Box flex={1} minHeight={0}>
      {!logQuery.isSuccess || !topicsQuery.isSuccess ? (
        <Loading type="circular">
          <Typography variant="h6" component="p">
            Loading...
          </Typography>
        </Loading>
      ) : (
        <Panels
          element={
            <ErrorBoundary fallback={<PanelErrorFallback />}>
              <VisualizationSwitch topics={topicsQuery.data} />
            </ErrorBoundary>
          }
        />
      )}
    </Box>
  );
}

function PanelErrorFallback() {
  const panel = usePanelContext();

  const playerActions = usePlayerActions();

  const { resetBoundary } = useErrorBoundary();

  function handleCloseOnError() {
    playerActions.closePanel(panel);
    resetBoundary();
  }

  return (
    <Error>
      <Typography variant="h5" component="p" paragraph>
        Unexpected error visualizing data
      </Typography>
      <Button variant="text" color="primary" onClick={handleCloseOnError}>
        Close panel
      </Button>
    </Error>
  );
}
